import {isCmsBuilderPath} from '../utils/cmsBuilderRoutes.mjs';
export default defineNuxtPlugin(nuxtApp => {
	const enabled = useRuntimeConfig().public.cmsEditorPreviewEnabled;
	if (enabled !== true && enabled !== 'true') return;

	let bridgeRequested = false;
	nuxtApp.hook('app:mounted', () => {
		if (!isCmsBuilderPath(window.location.pathname)) return;
		const query = new URLSearchParams(window.location.search);
		const signedPreview = ['version_id', 'preview_expires', 'preview_token', 'preview_editor_origin']
			.every(key => String(query.get(key) || '').trim() !== '');
		if (!signedPreview || bridgeRequested) return;

		bridgeRequested = true;
		return import('../assets/js/cmsstaticcontent-editor-preview.js').catch(() => {
			document.documentElement.dataset.cmsstaticcontentEditorPreview = 'load-error';
		});
	});
});
